// ONE LESS LAP — Theme JS v4
document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initScrollAnimations();
  initCounters();
  initDonateAmounts();
  initNewsletter();
  initFFH();
  initStoryFilters();
});

function initMobileMenu() {
  const toggle = document.querySelector('.mobile-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (!toggle || !mobileNav) return;
  toggle.addEventListener('click', () => {
    const open = mobileNav.style.display === 'block';
    mobileNav.style.display = open ? 'none' : 'block';
    toggle.setAttribute('aria-expanded', String(!open));
  });
}

function initScrollAnimations() {
  const fadeEls = document.querySelectorAll('.fade-up');
  if (!fadeEls.length || !('IntersectionObserver' in window)) return;
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('visible'), i * 70);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  fadeEls.forEach(el => obs.observe(el));
}

function initCounters() {
  if (!('IntersectionObserver' in window)) return;
  const counters = document.querySelectorAll('[data-count]');
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = parseInt(el.getAttribute('data-count'));
      const suffix = el.getAttribute('data-suffix') || '';
      let current = 0;
      const inc = target / 55;
      const timer = setInterval(() => {
        current = Math.min(current + inc, target);
        el.textContent = Math.floor(current).toLocaleString() + suffix;
        if (current >= target) clearInterval(timer);
      }, 22);
      obs.unobserve(el);
    });
  }, { threshold: 0.5 });
  counters.forEach(el => obs.observe(el));
}

function initDonateAmounts() {
  document.querySelectorAll('.amt-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.amt-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
}

function initNewsletter() {
  const nlForm = document.querySelector('.nl-form');
  if (!nlForm) return;
  nlForm.addEventListener('submit', e => {
    e.preventDefault();
    const inp = nlForm.querySelector('input[type="email"]');
    if (inp && inp.value) {
      inp.value = '';
      inp.placeholder = '✓ Thanks for subscribing!';
      inp.disabled = true;
    }
  });
}

function initStoryFilters() {
  const btns = document.querySelectorAll('.story-filter-btn');
  if (!btns.length) return;
  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      btns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const filter = btn.dataset.filter;
      document.querySelectorAll('.story-card[data-category]').forEach(card => {
        card.style.display = (filter === 'all' || card.dataset.category === filter) ? '' : 'none';
      });
    });
  });
}

function initFFH() {
  const grid = document.getElementById('ffh-grid');
  if (!grid) return;
  const searchInput = document.getElementById('ffh-search');
  const catFilter = document.getElementById('ffh-category');
  const typeFilter = document.getElementById('ffh-type');
  const servesFilter = document.getElementById('ffh-serves');
  const locFilter = document.getElementById('ffh-location');
  const featToggle = document.getElementById('ffh-featured');
  const sortSelect = document.getElementById('ffh-sort');
  const resultsInfo = document.getElementById('ffh-info');

  function filter() {
    const cards = Array.from(grid.querySelectorAll('.resource-card'));
    const s  = searchInput  ? searchInput.value.toLowerCase()  : '';
    const c  = catFilter    ? catFilter.value.toLowerCase()    : '';
    const t  = typeFilter   ? typeFilter.value.toLowerCase()   : '';
    const sv = servesFilter ? servesFilter.value.toLowerCase() : '';
    const l  = locFilter    ? locFilter.value.toLowerCase()    : '';
    const f  = featToggle   ? featToggle.checked               : false;
    let visible = 0;
    cards.forEach(card => {
      const match =
        (!s || [card.dataset.name, card.dataset.org, card.dataset.desc].some(v => (v||'').toLowerCase().includes(s))) &&
        (!c  || (card.dataset.category||'').toLowerCase().includes(c)) &&
        (!t  || (card.dataset.type||'').toLowerCase().includes(t)) &&
        (!sv || (card.dataset.serves||'').toLowerCase().includes(sv)) &&
        (!l  || (card.dataset.area||'').toLowerCase().includes(l)) &&
        (!f  || card.dataset.featured === 'true');
      card.style.display = match ? '' : 'none';
      if (match) visible++;
    });
    if (resultsInfo) resultsInfo.textContent = `Showing ${visible} of ${cards.length} resources`;
    let noRes = grid.querySelector('.no-results');
    if (visible === 0) {
      if (!noRes) {
        noRes = document.createElement('div');
        noRes.className = 'no-results';
        noRes.textContent = 'No resources match your search. Try adjusting your filters.';
        grid.appendChild(noRes);
      }
    } else if (noRes) noRes.remove();
  }

  function sort() {
    if (!sortSelect) return;
    const cards = Array.from(grid.querySelectorAll('.resource-card'));
    const val = sortSelect.value;
    cards.sort((a, b) => {
      if (val === 'name-asc') return (a.dataset.name||'').localeCompare(b.dataset.name||'');
      if (val === 'name-desc') return (b.dataset.name||'').localeCompare(a.dataset.name||'');
      return 0;
    });
    cards.forEach(c => grid.appendChild(c));
  }

  [searchInput, catFilter, typeFilter, servesFilter, locFilter, featToggle].forEach(el => {
    if (el) el.addEventListener(el.type === 'checkbox' ? 'change' : 'input', filter);
  });
  if (sortSelect) sortSelect.addEventListener('change', () => { sort(); filter(); });
  filter();
}
